<template>
    <div>
      
    </div>
</template>

<script>
// import mqtt from 'mqtt'
// import { MQTT_SERVICE, MQTT_USERNAME, MQTT_PASSWORD } from './sysconstant.js'
var client;
export default {
  name: 'Mqtt',
  props:['imei'],
  data () {
    return {
      msg: '',
      myimei:'',
      sendmsg:'',
      times:1,
      in_times:1,
      timeid:[],
      machineStatus:"N",
      er_msg: ''
    }
  },
  created () {
    // this.testOnLine()
  },
  methods: {
    testOnLine(imei){
      var url = "https://home.hrcc8.com/home/api/c/testOnline/?imei="+imei
      this.axios.get(url)
      .then((res) =>{
        console.log(res)
        if(res.data.code === 20000){
          if(this.machineStatus == "N"){
            this.machineStatus = "on";
          }
          this.$emit("machineStatus","on")
        }else{
          this.machineStatus = "off";
          this.$emit("machineStatus","off",res.data.msg)
        }
      })
      .catch((error)=>{
        this.$emit("machineStatus","off",error)
      })
    },
//     mqttMSG (myimei) {
//         this.startTimer()
//         this.myimei = myimei;
//         this.sendmsg = '{"IMEI":"'+ myimei +'","Command":10}';
//         console.log('start')
//         this.er_msg = 'ER:0'
//         var sj = Math.floor((Math.random()*100)+1);
//         const options = {
//           // connectTimeout: 60000,
//           connectTimeout: 4000,
//           reconnectPeriod: 1000,
//           keepalive:60,
//           clientId: "app-c-6867"+(new Date()).valueOf()+"-"+sj,
//           username: MQTT_USERNAME,
//           password: MQTT_PASSWORD,
//           clean: true
//         }
//         //console.log(options);
//       client = mqtt.connect(MQTT_SERVICE, options)
//       // mqtt连接
//       client.on('connect', (e) => {
//         console.log('连接成功:1')
//         this.er_msg = this.er_msg +'-'+'1'
//         client.subscribe('/topic/State1/'+this.myimei, { qos: 0 }, (error) => {
//           if (!error) {
//             console.log('订阅成功2')
//             this.er_msg = this.er_msg + '-'+ '2'
//             //发布一个消息
//             console.log(this.sendmsg)
//             client.publish('/topic/get/'+this.myimei,this.sendmsg)
//             console.log('****')
//             console.log(this.myimei)
//             this.sendmessage()
//           } else {
//             console.log('订阅失败3')
//             this.er_msg = this.er_msg + '-'+ '3'
//             client.end();
//           }
//         })
//       })
 
//       // 接收消息处理
//       client.on('message', (topic, message) => {
//         console.log('收到来自', topic, '的消息', message.toString());
//         this.er_msg = this.er_msg + '-'+ '4'
//         this.msg = message.toString();
//         //将返回的数据转为json
//         var data = JSON.parse(this.msg) 
//         //console.log(data)
//         //关闭定时器
//         if(data.State1 == "OK"){
//           this.clearTime();
//           if(this.machineStatus == "N")
//           {
//             this.machineStatus = "on";
//             this.$emit("machineStatus","on")
//           }
//         }
//         //关闭连接
//         client.end();
//       })
//       // 断开发起重连
//       client.on('reconnect', (error) => {
//         console.log('正在重连:', error);
//         this.er_msg = this.er_msg + '-'+ '5'
//         //关闭定时器
//         //this.clearTime()
//         //关闭连接
//         //client.end();
//       })
//       // 连接异常处理
//       client.on('error', (error) => {
//         console.log('连接失败:', error);
//         this.er_msg = this.er_msg + '-'+ '6'
//         this.clearTime()
//         //关闭连接
//         //client.end();
//       })
//     },
//     sendmessage:function(){
//       var that = this
//       //启用定时器  间隔时间2s
//       this.timeid.push(setInterval(function(){
//         client.publish('/topic/get/'+that.myimei,that.sendmsg)
//         that.times += 1;
//         //console.log('sendmessage');
//         console.log('sendmessage次数' + that.times);
//         that.er_msg = that.er_msg + '-'+ 's'+that.times
//         //重发3次关闭定时器
//         if(that.times > 3){
//           //关闭连接
//           client.end();
//           console.log(that.times);
//           that.clearTime()
//           //再过2秒判断  如果没有接收到返回消息就将货机状态置为离线
//           that.timeoutChangeStatus('货机连接异常，请重新扫码!' + that.er_msg);
//         }
//       },2000))
//     },
//     startTimer:function(){
//       var that = this
//       //启用定时器  间隔时间4s
//       this.timeid.push(setInterval(function(){
//         that.in_times += 1;
//         //console.log('startTimer');
//         console.log('startTimer次数' + that.in_times);
//         that.er_msg = that.er_msg + '-'+ 't'+that.in_times
//         //重发3次关闭定时器
//         if(that.in_times > 3){
//           // console.log(that.times);
//           that.clearTime()
//           //再过4秒判断  如果没有接收到返回消息就将货机状态置为离线
//           that.timeoutChangeStatus('网络异常，请重新扫码'+ that.times);
//         }
//       },4000))
//     },
//     clearTime:function(){
//       console.log("clearTime")
//       console.log("timeid长度"+ this.timeid.length)
//       this.timeid.forEach(element => {
//         console.log(element)
//         clearInterval(element);
//       });
//       //清空数组
//       this.timeid = []
//     },
//     timeoutChangeStatus:function(msg){
//       if(this.machineStatus == "N")
//       {
//         this.machineStatus = "off";
//         this.$emit("machineStatus","off",msg)
//         console.log(this.machineStatus)
//       }
//     }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Mqtt/Mqtt.vue